import Loader from '@/components/ui/loader';

// The AuthGuard handles all routing logic: after auth + workspace bootstrap,
// the user is redirected to /workspace/:id or /create-workspace.
// This page only renders momentarily during the transition.
export function HomePage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader />
    </div>
  );
}
